import { validateEmailFormat, validatePhoneNumber } from './validationUtils';

/**
 * Detect whether an identifier is an email address.
 * @param {string} identifier
 * @returns {boolean}
 */
export const isEmailIdentifier = (identifier) => {
  return typeof identifier === 'string' && identifier.includes('@');
};

/**
 * Build auth request body with email or phoneNumber from a single identifier.
 * @param {string} identifier
 * @returns {{ email: string } | { phoneNumber: string }}
 */
export const buildAuthIdentifierBody = (identifier) => {
  const value = (identifier || '').trim();
  if (isEmailIdentifier(value)) {
    return { email: value };
  }
  return { phoneNumber: value };
};

/**
 * Validate a login/recovery identifier (email or supported phone format).
 * @param {string} identifier
 * @returns {{ isValid: boolean, type: 'email' | 'phone' | null, message?: string, formatted?: string }}
 */
export const validateAuthIdentifier = (identifier) => {
  const value = (identifier || '').trim();
  if (!value) {
    return { isValid: false, type: null, message: 'Identifier is required' };
  }

  if (isEmailIdentifier(value)) {
    if (!validateEmailFormat(value)) {
      return { isValid: false, type: 'email', message: 'Invalid email format' };
    }
    return { isValid: true, type: 'email', formatted: value };
  }

  const phoneValidation = validatePhoneNumber(value);
  if (!phoneValidation.isValid) {
    return {
      isValid: false,
      type: 'phone',
      message: 'Invalid phone number. Use Rwanda (+250), Ethiopia (+251) or Senegal (+221) format.',
    };
  }

  return {
    isValid: true,
    type: 'phone',
    formatted: phoneValidation.formatted,
  };
};
